import React from "react";
import Work1 from "../Images/Lipsmakeover2.jpg";
import Work2 from "../Images/Hairstyle.jpg";
import Work3 from "../Images/MakeUp.jpg";
import Work4 from "../Images/Photod-1.jpeg";
import Work5 from "../Images/Photod-2.jpeg";
import Work6 from "../Images/Photod-3.jpeg";


const Ourwork=()=>{
    return(
        <section className="ftco-section1" style={{backgroundColor:"black"}}>
    <div className="container">
      <div className="row justify-content-center mb-5 pb-3">
        <div className="col-md-7 heading-section text-center ftco-animate">
          <h2 className="mb-4 blackthemegradient">Our Work</h2>
          <p className="ourworkdesc">
          At Janushree Beauty Parlour, we take pride in delivering exceptional beauty services that cater to all your grooming needs.
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src={Work4}
              className="img-fluid"
              alt="Colorlib Template"
            />
            {/* <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Lips Makeover</h3>
              </div>
            </div> */}
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src={Work5}
              className="img-fluid"
              alt="Colorlib Template"
            />
            {/* <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Hair Style</h3>
              </div>
            </div> */}
          </a>
        </div>
        <div className="col-md-4 ftco-animate">
          <a href="#" className="work-entry">
            <img
              src={Work6}
              className="img-fluid"
              alt="Colorlib Template"
            />
            {/* <div className="info d-flex align-items-center">
              <div>
                <div className="icon mb-4 d-flex align-items-center justify-content-center">
                  <span className="icon-search" />
                </div>
                <h3>Makeup</h3>
              </div>
            </div> */}
          </a>
        </div>
      </div>
    </div>
  </section>
    );
}

export default Ourwork;